const SetFavicon = (colours) => {



    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <rect x="1" y="1" width="30" height="30" fill="${colours.background ? colours.background : '#FFFFFF'}" stroke-width="0" />
        <rect x="1" y="1" width="20" height="20" fill="${colours.text ? colours.text : '#000000'}" stroke-width="0" />
      </svg>
    `;
  
    const link = document.querySelector("link[rel='icon']") || document.createElement('link');
    link.type = 'image/svg+xml';
    link.rel = 'icon';
    link.href = 'data:image/svg+xml;base64,' + btoa(svg);
  
    document.head.appendChild(link);
};

export default SetFavicon